export default __webpack_public_path__ + "static/sms-uk-d89d0af58d2a0884a802b56765a9fee7.webp";